import type { App, Plugin } from 'vue'
import Transition from './transition'

Transition.install = function (app: App) {
  app.component(Transition.name, Transition)
  return app
}

export default Transition as typeof Transition & Plugin
